import { SLOPE, EXPONENT } from '@r3l/common';

export const URL_REGEX = new RegExp(
  // eslint-disable-next-line
  /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%_\+~#=]{2,256}\.[a-z]{2,10}\b([-a-zA-Z0-9@:%_\+~#?&//=]*)/g
);

export function getTitle({ post, link, maxLength }) {
  if (post?.type === 'image') return null;
  let title = link?.title || post?.title;
  const fromBody = !title || title === '';
  title = title || post?.body;

  const limit = maxLength || 160;
  if (fromBody) {
    const lines = title?.split(/\n/);
    title = lines?.slice(0, 1).join('\n');
    if (!title) return 'Untitled';
    if (title?.length <= limit) return title;
    return title?.substr(0, title.lastIndexOf(' ', limit)) + '...';
  }

  if (title && title.length > limit) {
    title = title.substr(0, title.lastIndexOf(' ', limit)) + '...';
  }
  title = title && title.trim();
  return title || 'Untitled';
}

export function getFavIcon(domain) {
  return `https://api.faviconkit.com/${domain}/144`;
  // return `https://s2.googleusercontent.com/s2/favicons?domain=${domain}`;
}

export const getPostUrl = (community, post) => {
  if (!post) return null;
  const { parentPost } = post;
  const postId = parentPost ? parentPost._id || parentPost : post._id || post;
  const commentId = parentPost ? '/' + (post._id || post) : '';
  return `/${community}/post/${postId}${commentId}`;
};

export const computeShares = ({ post, stakedTokens }) => {
  const { balance: existingStake } = post.data;
  const nexp = EXPONENT + 1;

  const totalStake = existingStake + stakedTokens;

  const oldShares = (SLOPE / nexp) * existingStake ** (1 / nexp);
  const newShares = (SLOPE / nexp) * totalStake ** (1 / nexp);

  const shares = newShares - oldShares;

  if (shares < 0) return 0;
  return shares;
};

export const getPostType = ({ post }) => {
  const type = !post.parentPost && post.url ? 'link' : post.type;
  return type;
};
